import React, { useEffect } from "react";
import { useState } from "react";
import { Dialog } from "../dialog";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ApplicationState } from "../../../../store";
import { ROUTES } from "../../../../configs/routes";

interface Props {
  isTimeOutDialogOpen: boolean;
  testId?: string;
}
export const IdleTimeoutDialog: React.FC<Props> = (props) => {
  const { isTimeOutDialogOpen, testId } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const [showTimeoutDialog, setSshowTimeoutDialog] = useState<boolean>(false);
  const isLoggedIn = useSelector<ApplicationState, boolean>(
    (state) => state.auth.isLoggedIn
  );

  useEffect(() => {
    if (isTimeOutDialogOpen && !isLoggedIn) {
      setSshowTimeoutDialog(true);
      // Drop the idle timeout query param through the router so a refresh, or
      // a later auth change on this page, doesn't show the dialog again
      history.replace(ROUTES.ROOT);
    }
  }, [isTimeOutDialogOpen, isLoggedIn]);

  return (
    <Dialog
      id="timeout-dialog"
      testId={testId}
      show={showTimeoutDialog}
      title={t("PRIVACY_SESSION_TIMEOUT_TITLE")}
      body={`${t("PRIVACY_SESSION_TIMEOUT_BODY1")} ${"\n"} ${t(
        "PRIVACY_SESSION_TIMEOUT_BODY2"
      )} `}
      handleClose={() => {
        setSshowTimeoutDialog(false);
      }}
      buttonTitle={t("PRIVACY_DIALOG_OK")}
      isIdleDialog={true}
    />
  );
};
